import React, { Component } from 'react'
import { TableContainer, Table as TableUI, TableHead, TableCell, TableBody, TableRow, Paper, TablePagination, Icon, Checkbox, TextField, TableSortLabel, Tooltip, IconButton, Menu, Button, MenuItem, } from '@material-ui/core'
import { withRouter, Link } from 'react-router-dom'
import './Table.css'
import { AuthContext } from '../../context/authContext';

class Table extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rpp: 15,
      q: '',
      orderBy: '',
      order: 'asc',
      open: {},
      search: {},
      anchorEl: null,
      row: null,
      index: null,
    }

    this.rows = [
      { id: 1, valor1: 1, valor2: 2, valor3: 3 },
      { id: 2, valor1: 2, valor2: 2, valor3: 3 },
      { id: 3, valor1: 2, valor2: 2, valor3: 3 },
    ]

    this.page = 0;
    this.rpp = 15;
    this.anchorRef = React.createRef();
    this.inputRefs = {};
  }


  componentDidMount() {
    // console.log(this.props.table);
    let search = {};
    this.rpp = this.props.table.rpp;
    this.page = this.props.table.page;
    const urlParams = new URLSearchParams(window.location.search);
    let q = urlParams.get('qt');
    if (q) {
      search = JSON.parse(q);
    }
    this.setState({ rpp: this.rpp, page: this.page, search })
  }

  changePage = (a, newPage) => {
    // console.log(newPage);
    const { search } = this.state;
    const { prevUrl } = this.props;
    const stringSearch = JSON.stringify(search)
    /* this.props.history.push({
      pathname: this.props.location.pathname,
      search: 
    }) */
    if (window.history.pushState) {
      const location = window.location.href.split('?');
      let newurl = `${location[0]}?page=${newPage}&qt=${stringSearch}`;
      if (prevUrl) {
        let replaceUrl = this.removeParam('page', window.location.href);
        replaceUrl = this.removeParam('qt', replaceUrl);
        newurl = `${replaceUrl}&page=${newPage}&qt=${stringSearch}`
      }
      window.history.pushState({ path: newurl }, '', newurl);
    }
    this.page = newPage;
    this.setState({ page: newPage })
    this.props.pag(this.page, this.rpp, stringSearch);
  }

  changeRowsPerPage = (a) => {
    // console.log(a.target.value);
    this.rpp = a.target.value;
    this.setState({ rpp: this.rpp })
    this.props.pag(this.page, this.rpp);
    // this.props.pag()
  }

  qChange = (val) => {
    this.setState({ q: val })
    // console.log(val)
    // if(val.length > 2)
    this.props.onSearch(val)
  }

  orderChange = (orderBy) => {
    const order = this.state.order === "asc" ? "desc" : "asc";
    this.setState({ orderBy, order })
    this.props.onOrder(orderBy, order)
  }

  handleToggleSearch = (e, field) => {
    const { open } = this.state;
    open[field] = e.currentTarget;
    this.setState({ open }, () => {
      this.inputRefs[field].focus()
    });
  }

  handleOnSearch = (e, field) => {
    const { search } = this.state;
    search[field] = e.target.value;
    this.setState({ search })
  }

  handleClickSearch = (field) => {
    const { search, open } = this.state;
    const stringSearch = JSON.stringify(search)
    this.page = 0;
    open[field] = null;
    // this.props.onSearch(stringSearch);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?page=${this.page}&qt=${stringSearch}`,
    })
    this.setState({ q: stringSearch, open, page: this.page })
    this.props.pag(this.page, this.rpp, stringSearch);
  }

  handleClickReset = (field) => {
    const { search, open } = this.state;
    open[field] = null;
    delete search[field]
    const stringSearch = JSON.stringify(search)
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?page=${this.page}&qt=${stringSearch}`,
    })
    this.props.onSearch(stringSearch);
    this.setState({ search, open, q: stringSearch })
  }

  removeParam(key, sourceURL) {
    let rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }

  handleClickMenu = (row, index) => {
    return (event) => {
      this.setState({
        ...this.state,
        anchorEl: event.currentTarget,
        row,
        index
      });

    }
  };

  handleCloseMenu = () => {
    this.setState({
      ...this.state,
      anchorEl: null,
      row: null,
      index: null,
    });
  };

  render() {
    const { table, onAction, pagination = true, modUrl } = this.props;
    const { orderBy, order, open, search } = this.state;
    const { hasAccess } = this.context;

    return (
      <div style={{ marginTop: 15 }} >
        <Paper>
          <div className="table-top">
            {table.title &&
              <h1>{table.title}</h1>
            }
          </div>
          <TableContainer>
            <TableUI aria-label="table" size="small">
              <TableHead>
                <TableRow>
                  {table.actions.length > 0 && (
                    <TableCell align="left" className="actions">
                      Acciones
                    </TableCell>
                  )}
                  {table.fields.map((field) => (
                    <TableCell key={field.id}>
                      <div style={{ display: "flex" }}>
                        <TableSortLabel
                          active={orderBy === field.id}
                          direction={orderBy === field.id ? order : "asc"}
                          onClick={() => {
                            this.orderChange(field.id);
                          }}
                        >
                          {field.label}
                        </TableSortLabel>
                        <div>
                          <IconButton
                            onClick={(e) => {
                              this.handleToggleSearch(e, field.id);
                            }}
                            aria-haspopup="true"
                            aria-controls={`customized-menu-${field.id}`}
                          >
                            <Icon style={{ color: search[field.id] ? 'red' : 'unset' }} >search</Icon>
                          </IconButton>
                          <Menu
                            elevation={0}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            id={`customized-menu-${field.id}`}
                            anchorEl={open[field.id]}
                            keepMounted
                            open={!!open[field.id]}
                            onClose={() => {
                              this.handleToggleSearch(
                                { currentTarget: null },
                                field.id
                              );
                            }}
                          >
                            <div style={{
                              padding: 3,
                              display: 'flex',
                              flexFlow: 'column nowrap',
                              justifyContent: 'center',
                              alignItems: 'center',
                              boxShadow: "0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)"
                            }} >
                              <TextField
                                inputRef={el => this.inputRefs[field.id] = el}
                                size={"small"}
                                style={{ width: 140 }}
                                value={search[field.id] || ""}
                                onChange={(e) => this.handleOnSearch(e, field.id)}
                                onKeyUp={(e) => { if (e.keyCode === 13) { this.handleClickSearch(field.id) } }}
                                variant="outlined"
                                placeholder="Buscar"
                              ></TextField>
                              <div style={{ marginTop: 4 }}>
                                <Button size={"small"} color="primary" variant="outlined" style={{ marginRight: 3 }} onClick={() => { this.handleClickSearch(field.id) }} >
                                  Buscar
                                </Button>
                                <Button size={"small"} color="secondary" variant="outlined" onClick={() => { this.handleClickReset(field.id) }} >
                                  Reset
                                </Button>
                              </div>
                            </div>
                          </Menu>
                        </div>
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {table.rows.map((row, i) => (
                  <TableRow className='row-table' key={row.id || i}>
                    {table.actions.length > 0 && (
                      <TableCell className="actions" align="left">
                        <Button aria-controls="simple-menu" aria-haspopup="true" startIcon={<Icon color="primary" style={{ fontWeight: 'bolder' }}>more_vert</Icon>} onClick={this.handleClickMenu(row, i)} />
                      </TableCell>
                    )}
                    {table.fields.map((field, f) => (modUrl ? (<TableCell className='link-cell' key={f} >
                      <Link to={`${modUrl}/${row['id']}`} style={{ textDecoration: 'none', color: 'black', width: '100%' }} >
                        <div style={{ width: '100%', height: '32px', display: 'flex', alignItems: 'center' }} > {row[field.id]} </div>
                      </Link>
                    </TableCell>)
                      :
                      <TableCell key={f}  >
                        {(field.type === "checkbox" && (
                          <Checkbox
                            disabled={field.disabled}
                            checked={row[field.id] ? true : false}
                            onChange={(e) => {
                              if (field.callback) {
                                field.callback(
                                  { target: { value: e.target.checked } },
                                  i,
                                  field.id
                                );
                              }
                            }}
                            onBlur={(e) => {
                              if (field.onBlur) {
                                field.onBlur(
                                  { target: { value: e.target.checked } },
                                  i,
                                  field.id
                                );
                              }
                            }}
                          />
                        ))
                          || (field.type === "input" && (
                            <TextField
                              disabled={field.disabled}
                              variant="outlined"
                              value={row[field.id] || ""}
                              onChange={(e) => {
                                if (field.callback) {
                                  field.callback(e, i, field.id);
                                }
                              }}
                              onBlur={(e) => {
                                if (field.onBlur) {
                                  field.onBlur(e, i, field.id);
                                }
                              }}
                            />
                          ))
                          || row[field.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                {
                  table.rows.length === 0 && (
                    <TableRow> 
                      <TableCell colSpan={table.fields.length+1} style={{ textAlign: 'center' }} >
                        <h5>No hay registros</h5> 
                      </TableCell>
                    </TableRow>
                  )
                }
              </TableBody>
            </TableUI>
          </TableContainer>
          {pagination &&
            <TablePagination
              rowsPerPageOptions={[5, 9, 10, 15, 25, 30]}
              component="div"
              count={table.total}
              rowsPerPage={table.rpp}
              page={table.page}
              onPageChange={this.changePage}
              onRowsPerPageChange={this.changeRowsPerPage}
            />
          }
          <Menu
            id="simple-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleCloseMenu}
          >
            {table.actions.map((action, a) => hasAccess(action.access) ? (
              <MenuItem
                key={a}
                onClick={() => {
                  this.handleCloseMenu();
                  onAction(action.id, { ...this.state.row, row_index: this.state.index }, action.cb)
                }}
              >
                <Icon color="primary">
                  {action.icon}
                </Icon>
                <div style={{ marginLeft: 10 }} >{action.tooltip || action.id}</div>
              </MenuItem>
            ) : (
              <span key={a} />
            )
            )}
          </Menu>
        </Paper>
      </div>
    );
  }
}

Table.contextType = AuthContext;
export default withRouter(Table);